import {
  PlayerAnalyticsDataLayerEvent,
  PlayerAnalyticsDataLayerEventVoiceType,
  PlayerAnalyticsEventAction,
} from './types'

type TrackingPlayers = {
  [n: number]: {
    postId: number
    voiceType: PlayerAnalyticsDataLayerEventVoiceType
    duration: number
    currentTime: number
  }
}

export const analyticsPlayers: TrackingPlayers = {}

export function pushEvent(evt: Partial<PlayerAnalyticsDataLayerEvent>) {
  if (typeof window !== 'undefined' && 'dataLayer' in window) {
    window.dataLayer.push({
      event: 'audio',
      ...evt,
    })
  }
}

export function track(articleId: number, action: PlayerAnalyticsEventAction) {
  const player = analyticsPlayers[articleId]
  if (player) {
    pushEvent({
      action: action,
      post_id: player.postId,
      duration: player.currentTime,
      total_duration: player.duration,
      voice_type: player.voiceType,
    })
  }
}
